import React, { useState } from 'react';
import styles from './Portfolio.module.css';
import { Container } from '../../common/Container';
import { PortfolioCard } from './PortfolioCard';
import { PortfolioModal } from './PortfolioModal';
import { useIntersectionObserver } from '../../../hooks/useIntersectionObserver';
import { PortfolioItem } from '../../../types';
import portfolioData from '../../../data/portfolio.json';
import clsx from 'clsx';

export const Portfolio: React.FC = () => {
  const [ref, isVisible] = useIntersectionObserver<HTMLElement>({
    threshold: 0.1,
    triggerOnce: true,
  });

  const [selectedItem, setSelectedItem] = useState<PortfolioItem | null>(null);

  const portfolioItems = portfolioData as PortfolioItem[];

  const handleCardClick = (item: PortfolioItem) => {
    setSelectedItem(item);
  };

  const handleCloseModal = () => {
    setSelectedItem(null);
  };

  return (
    <section id="portfolio" className={styles.portfolio} ref={ref}>
      <Container>
        <div className={clsx(styles.portfolioContent, isVisible && styles.visible)}>
          <div className={styles.header}>
            <h2 className={styles.heading}>Apps</h2>
            <p className={styles.description}>
              Apps I've designed, built, and shipped.
            </p>
          </div>

          {/* Portfolio Grid */}
          <div className={styles.grid}>
            {portfolioItems.map((item, index) => (
              <PortfolioCard
                key={item.id}
                item={item}
                index={index}
                onClick={() => handleCardClick(item)}
              />
            ))}
          </div>
        </div>
      </Container>

      {/* Modal */}
      {selectedItem && (
        <PortfolioModal item={selectedItem} onClose={handleCloseModal} />
      )}
    </section>
  );
};
